import bookImage from "../../assets/images/subjectbook.png";
import emptyCalendarImage from "../../assets/images/cuate.png";
import studentAvatar from "../../assets/images/studentavatar.png";
import studentCsvHeaderImage from "../../assets/images/student-csv-header.png";

const logoImage = process.env.REACT_APP_PLATFORM_LOGO;

const IMAGES = {
    bookImage,
    logoImage,
    studentAvatar,
    emptyCalendarImage,
    studentCsvHeaderImage,
};

export default IMAGES;
